import React, { useContext, useEffect, useState } from 'react'
import { Col } from 'react-bootstrap'
import Card from 'react-bootstrap/Card'
import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

import {
  defaultToEmptyString,
  svgTextWrap,
  twoDigits,
} from '../../../assets/ts/formatting/formatting'
import { RoleContext } from '../../../store/role-context-provider'
import CustomTooltip from '../custom-tooltip'
import './charts.css'
import './piecharts.css'

// Function that renders a custom XAxis for the byCategories Chart
const CustomYAxisTick = ({ payload, x, y }: any) => {
  const textArray = svgTextWrap(payload.value, 8)

  return (
    <g transform={`translate(${x},${y})`}>
      <text className='barchartyaxis' style={{ fontSize: 10 }} textAnchor='end' x={0} y={'-20'}>
        {textArray.map((text) => (
          <tspan dy='1.2em' key={text} x='0'>
            {defaultToEmptyString(text)}
          </tspan>
        ))}
      </text>
    </g>
  )
}
CustomYAxisTick.displayName = 'CustomYAxis'

const CustomXAxisTick = ({ payload, x, y }: any) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text dx={-5} fill='#666' fontSize='11' textAnchor='start' x={0} y={5}>
        <tspan>
          {payload.value === 0
            ? defaultToEmptyString(payload.value)
            : defaultToEmptyString(twoDigits(payload.value))}
        </tspan>
      </text>
    </g>
  )
}
CustomXAxisTick.displayName = 'CustomXAxis'

const ByCategoryChart = ({
  DueOutsByCategory,
  categories,
  inquiryCategoryCounts,
  isDueOut,
  isDuedate,
}: any) => {
  const roleContext = useContext(RoleContext)
  const formattedData: any[] = []
  const catCounts = isDueOut ? DueOutsByCategory : inquiryCategoryCounts
  catCounts?.slice(0, 4)?.forEach((category) => {
    formattedData.push({
      name: isDuedate ? category.DueDate : category.CategoryCode,
      value: isDueOut ? category.DueOutGUID_count : category.InquiryGUID_count,
    })
  })

  formattedData.forEach((option) => {
    const category = categories.filter((cat) => cat.CategoryCode === option.name)
    if (category.length > 0) option.name = category[0].Category
  })
  return (
    <Col
      className='align-items-stretch w-100-important my-2 d-flex'
      lg={roleContext.isCSS && !isDueOut ? '6' : '4'}
      md={roleContext.isCSS && !isDueOut ? '12' : '6'}
      sm={12}
    >
      <Card className='w-100'>
        <Card.Body className='d-flex flex-column'>
          <div style={{ alignItems: 'center', display: 'flex', marginTop: 16, zIndex: 2 }}>
          {isDuedate && (<p
              style={{
                color: '#355062',
                fontSize: 12,
                marginBottom: 100,
                marginRight: 0,
                padding: 0,
                transform: 'rotate(-90deg)',
              }}
            >
              Overdue
            </p>)}
            <ResponsiveContainer height={300} width='98%'>
              <BarChart
                aria-label='By Category Chart'
                className='tooltiphidefocus'
                data={formattedData}
                layout='vertical'
                margin={{ bottom: 0, left: 0, right: 20, top: 0 }}
              >
                <Bar
                  dataKey='value'
                  fill='#61A3C6'
                  isAnimationActive={false}
                  layout='vertical'
                  maxBarSize={30}
                  radius={[0, 15, 15, 0]}
                  tabIndex={0}
                  viewBox='0 0 100 100'
                >
                  {formattedData.map((entry) => (
                    <Cell aria-label={entry.name} fill={`url(#color-uv)`} key={entry.name} />
                  ))}
                </Bar>
                <defs>
                  <linearGradient
                    id='color-uv'
                    spreadMethod='reflect'
                    x1='0'
                    x2='80%'
                    y1='0'
                    y2='0'
                  >
                    <stop offset='0' stopColor='#61A3C6' />
                    <stop offset='1' stopColor='#6DB8AC' />
                  </linearGradient>
                </defs>
                <XAxis
                  allowDecimals={false}
                  dataKey='value'
                  domain={[0, 'auto']}
                  interval='preserveStartEnd'
                  stroke='#eaf0f4'
                  strokeWidth={3}
                  tick={CustomXAxisTick}
                  tickLine={false}
                  type='number'
                  width={20}
                />
                <YAxis
                  dataKey='name'
                  height={80}
                  interval={0}
                  stroke='#eaf0f4'
                  strokeWidth={2}
                  tick={CustomYAxisTick}
                  tickLine={false}
                  type='category'
                  width={110}
                />
                <Tooltip
                  content={<CustomTooltip />}
                  cursor={{ fill: 'transparent' }}
                  isAnimationActive={false}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
          <div style={{ fontSize: '12px', margin: '0 auto' }}>
            <p>{isDueOut ? 'Due Outs' : 'Inquiries'}</p>
          </div>
        </Card.Body>
      </Card>
    </Col>
  )
}

export default ByCategoryChart
